import { Component, OnInit,Output,EventEmitter,Input, ViewChild } from '@angular/core';
import { daLocale } from 'ngx-bootstrap';
import{QuestionManagementService} from '../../../Services/question-management/question-management.service';
import { QuestionListComponent } from '../question-list/question-list.component';
@Component({
  selector: 'app-question-selection-template',
  templateUrl: './question-selection-template.component.html',
  styleUrls: ['./question-selection-template.component.css']
})
export class QuestionSelectionTemplateComponent implements OnInit {

  Hidden:boolean=false;
  @Input() subjectById:any;
  DisableNextButton:boolean=false;

  @Output() ClickNextButton: EventEmitter<any> = new EventEmitter<any>();

  constructor(public service:QuestionManagementService) {

  }
  @ViewChild('childComponent') child:QuestionListComponent;
  ngOnInit() {
    this.getQuestionTemplateList();
    console.log(this.subjectById);
  }

  selectedtemplate(data:any){
  //   for (let item of this.QuestionTemplatelist) {
  //     if (item.Question_Template_ID==data) {
  //        item.checkedflag=true;
  //     }
  //     else{
  //       item.checkedflag=false;
  //     }
  // }
  this.selecttemplate(data)
  }

  QuestionTemplatelist:any;
  Question:any;
  getQuestionTemplateList(){

    this.service.GetQuestionTemplate({'LoggedInUserID':"Vel_S_Pil_1"}).subscribe((i:any)=>{
      this.Question=i;
      this.QuestionTemplatelist=this.Question.result;

      this.QuestionTemplatelist.map((obj: { checkedflag: boolean; }) => {
      obj.checkedflag = false;
      return obj;
  });
    // }).catch((e:any)=>{
    //   this.QuestionTemplatelist=null;
    // });
  }, error => {  console.log(error) }
  );
  }

  NextButtonflag:boolean
  Next(){
    this.ClickNextButton.emit(this.QuestionTemplatelist);

  }

  templateselection(data:any){
    this.selecttemplate(data.target.value)
  }
  checked:boolean
  selecttemplate(data:any){

   for (let item of this.QuestionTemplatelist) {
    if(item.Question_Template_ID==data)
    {
      if(item.checkedflag){
        item.checkedflag=false;
        this.DisableNextButton=false;
      }
      else{
        item.checkedflag=true;

      }
    }
    else{
      item.checkedflag=false;
    }
  }
  for (let item of this.QuestionTemplatelist) {
    if(item.checkedflag){
      this.DisableNextButton=true;
     }
  }
}

}
